import script from "./PendingLeavesView.vue?vue&type=script&setup=true&lang=js"
export * from "./PendingLeavesView.vue?vue&type=script&setup=true&lang=js"

import "./PendingLeavesView.vue?vue&type=style&index=0&id=fd970ff8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd970ff8"]])

export default __exports__